export default __webpack_public_path__ + "static/media/loginImage.b031e767.jpg";